/* screehopper: The shell pitches through compression and recovery as the legs gather.
 * Eight authored 16x16 poses; palette and gameplay bounds are unchanged. */

export const screehopper_0 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oooo......',
  '....ommmmmmo....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '....oNnNnNno....',
  '....noonNoon....',
  '...N........N...',
  '..o..........o..',
  '................',
  '................',
];

export const screehopper_1 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '.....oooooo.....',
  '....ommmmmmo....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '.....oNnnNo.....',
  '....noonNoon....',
  '....N......N....',
  '...o........o...',
  '................',
  '................',
];

export const screehopper_2 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oooo......',
  '.....ommmmo.....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '...oNnNnNnNno...',
  '....noonNoon....',
  '.....N....N.....',
  '....o......o....',
  '................',
  '................',
];

export const screehopper_3 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '.....oooooo.....',
  '.....ommmmo.....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '....oNnNnNno....',
  '....noonNoon....',
  '....N......N....',
  '....o......o....',
  '................',
  '................',
];

export const screehopper_4 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oooo......',
  '....ommmmmmo....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '....oNnNnNno....',
  '....noonNoon....',
  '...N........N...',
  '...o........o...',
  '................',
  '................',
];

export const screehopper_5 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '.....oooooo.....',
  '....ommmmmmo....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '.....oNnnNo.....',
  '....noonNoon....',
  '..N..........N..',
  '..o..........o..',
  '................',
  '................',
];

export const screehopper_6 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oooo......',
  '.....ommmmo.....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '...oNnNnNnNno...',
  '....noonNoon....',
  '...N........N...',
  '.o............o.',
  '................',
  '................',
];

export const screehopper_7 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '.....oooooo.....',
  '.....ommmmo.....',
  '...onNeNnNeNo...',
  '...oNnNnNnNno...',
  '....oNnNnNno....',
  '....noonNoon....',
  '....N......N....',
  '..o..........o..',
  '................',
  '................',
];
